import { all, takeLatest, put } from 'redux-saga/effects';

import * as actions from '../redux/googleTagManager';
import { actions as errorActions } from '@dragonfruit/redux/error';
import { UNLIMITED_QUESTION_QUOTA } from '@dragonfruit/utils/quotaParser';

export function* sendGtmEvent(action) {
  const { eventName, data = {} } = action.payload;
  try {
    const event = {
      event: eventName,
      ...data,
    };

    // If the event passes num_items variable
    // change num_items (0) for unlimited plans
    // to 9999999. Need to check if the variable is
    // not undefined as 0 (int) will be falsy
    if (data.num_items !== undefined) {
      event.num_items = data.num_items || UNLIMITED_QUESTION_QUOTA;
    }
    const dataLayer = (window && window.dataLayer) || [];

    dataLayer.push(function() {
      this.reset();
    });

    dataLayer.push(event);

    yield put(actions.sendGtmEventSuccess());
  } catch (err) {
    yield put(actions.sendGtmEventError(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([takeLatest(actions.SEND_GTM_EVENT, sendGtmEvent)]);
}



// WEBPACK FOOTER //
// ./app/sagas/googleTagManager.js